import React from 'react'
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import List from '../../list/list'
import ListExpandable from '../../list/list-expandable'
import Text from '../../form/form-text'
import Textarea from '../../form/form-textarea'
import Upload from '../../form/upload/file'

import DatePicker from '../../form/form-date-time-picker'
import Select from '../../form/form-select'

class ModuleSwellyWidget extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            data: this.props,
            disabled: this.props.disabled
        }
        this.i18n = 'app.modules.components.'
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({disabled: nextProps.disabled})
    }

    render() {
        let { client, name, page, parameter, title } = this.state.data;
        let { disabled } = this.state;

        return <div className="module-bitmovin">
            <Text disabled={disabled} label={'app.title'} value={title} />
            <Text disabled={disabled} label={this.i18n + 'client'} value={client} />
            <Text disabled={disabled} label={'app.name'} value={name} />
            <Text disabled={disabled} label={'app.page'} value={page} />
            <Text disabled={disabled} label={this.i18n + 'parameter'} value={parameter} />
        </div>
    }
}

ModuleSwellyWidget.propTypes = {
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool, // souhld be .isRequired,
    isCustom: PropTypes.bool, // souhld be .isRequired,,
    title: PropTypes.string,
    client: PropTypes.string,
    name: PropTypes.string,
    page: PropTypes.string,
    parameter: PropTypes.string
}

export default ModuleSwellyWidget;

